// Quiz — los scherm. Player-picker, scores, random ongeantwoorde vraag.

import { setTitle } from '../main.js'
import { icon } from '../icons.js'
import { getStore, setGameState } from '../store.js'
import { setState } from '../api.js'
import { esc, renderPlayerPick, renderScoresStrip, wirePlayerPick } from './_shared.js'

function pickQuestion(ctx) {
  const store = getStore()
  const done = store.game.quizDone
  const all = ctx.data.quiz ?? []
  const remaining = all.filter(q => !done.has(q.id))
  if (!remaining.length) return null
  return remaining[Math.floor(Math.random() * remaining.length)]
}

function renderQuizCard(ctx) {
  const q = pickQuestion(ctx)
  const total = (ctx.data.quiz ?? []).length
  const done = getStore().game.quizDone.size

  if (!q) {
    return `
      <div class="card">
        <h2>Quiz</h2>
        <p>Alle ${total} vragen beantwoord! Goed gedaan.</p>
        <div class="btn-row">
          <button class="btn secondary" id="quiz-reset">${icon('rotate')} Quiz opnieuw beginnen</button>
        </div>
      </div>`
  }
  return `
    <div class="card quiz-card" id="quiz-card" data-qid="${esc(q.id)}">
      <p class="subtitle">Vraag ${done + 1} van ${total}${q.difficulty ? ` · moeilijkheid ${q.difficulty}` : ''}</p>
      <h2>${esc(q.question)}</h2>
      <div class="quiz-options">
        ${q.options.map((opt, i) => `<button class="quiz-option" data-i="${i}">${esc(opt)}</button>`).join('')}
      </div>
      <div id="quiz-feedback" style="margin-top:10px"></div>
    </div>
  `
}

function wireCard(root, ctx) {
  // Reset
  const resetBtn = root.querySelector('#quiz-reset')
  if (resetBtn) {
    resetBtn.addEventListener('click', async () => {
      setGameState({ quizDone: [] })
      try { await setState({ quizDone: [] }) } catch {}
      root.querySelector('#quiz-section').innerHTML = renderQuizCard(ctx)
      wireCard(root, ctx)
    })
  }

  const card = root.querySelector('#quiz-card')
  if (!card) return
  const qid = card.dataset.qid
  const q = (ctx.data.quiz ?? []).find(x => x.id === qid)
  if (!q) return

  card.querySelectorAll('.quiz-option').forEach(b => {
    b.addEventListener('click', async () => {
      const i = Number(b.dataset.i)
      const correct = i === q.answerIndex
      card.querySelectorAll('.quiz-option').forEach((other, idx) => {
        other.disabled = true
        if (idx === q.answerIndex) other.classList.add('correct')
        else if (idx === i) other.classList.add('wrong')
      })
      const fb = card.querySelector('#quiz-feedback')
      const explanation = q.explanation ? `<p>${esc(q.explanation)}</p>` : ''
      const more = q.compendiumId
        ? `<a class="btn secondary" href="#/encyclopedie/${q.compendiumId}">Lees meer ›</a>`
        : (q.personId ? `<a class="btn secondary" href="#/people/${q.personId}">Open ›</a>`
        : (q.nodeId ? `<a class="btn secondary" href="#/node/${q.nodeId}">Naar plek ›</a>` : ''))
      fb.innerHTML = `
        <p><strong>${correct ? 'Goed!' : 'Helaas.'}</strong></p>
        ${explanation}
        <div class="btn-row">${more}<button class="btn" id="quiz-next">Volgende ›</button></div>
      `

      const store = getStore()
      const nextDone = new Set(store.game.quizDone)
      nextDone.add(q.id)
      const updates = { quizDone: [...nextDone] }
      if (correct && store.player.name) {
        const pts = q.difficulty === 3 ? 3 : q.difficulty === 1 ? 1 : 2
        const scores = { ...store.game.scores, [store.player.name]: (store.game.scores[store.player.name] ?? 0) + pts }
        updates.scores = scores
        setGameState({ quizDone: [...nextDone], scores })
      } else {
        setGameState({ quizDone: [...nextDone] })
      }
      try { await setState(updates) } catch (e) { console.warn('quiz-state niet opgeslagen', e) }

      const scoresEl = root.querySelector('#scores-section')
      if (scoresEl) scoresEl.innerHTML = renderScoresStrip(ctx)

      fb.querySelector('#quiz-next')?.addEventListener('click', () => {
        root.querySelector('#quiz-section').innerHTML = renderQuizCard(ctx)
        wireCard(root, ctx)
      })
    })
  })
}

export function renderQuiz(root, ctx) {
  setTitle('')
  root.innerHTML = `
    <div class="page">
      <div class="crumbs"><a href="#/home">‹ Home</a></div>
      <h1 class="title">Quiz</h1>
      ${renderPlayerPick(ctx)}
      <div id="scores-section">${renderScoresStrip(ctx)}</div>
      <div id="quiz-section">${renderQuizCard(ctx)}</div>
    </div>
  `
  wirePlayerPick(root, () => {
    root.querySelector('#scores-section').innerHTML = renderScoresStrip(ctx)
  })
  wireCard(root, ctx)
}
